import { HTTP_CP_HelpCase } from '@api-new/caseservice';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { helpCasesAdapter } from '@shared/store/help-cases/help-cases.reducer';
import { HelpCasesState } from '@shared/store/help-cases/help-cases.state';

const { selectAll, selectEntities } = helpCasesAdapter.getSelectors();

export const selectHelpCasesState = createFeatureSelector<HelpCasesState>('helpCases');

export const selectHelpCases = createSelector(selectHelpCasesState, (helpCasesState: HelpCasesState) => selectAll(helpCasesState));

export const selectHelpCaseEntities = createSelector(selectHelpCasesState, (helpCasesState: HelpCasesState) =>
  selectEntities(helpCasesState),
);

export const selectHelpCase = (helpCaseId: string) =>
  createSelector(selectHelpCaseEntities, (helpCaseEntities: Dictionary<HTTP_CP_HelpCase>) => helpCaseEntities[helpCaseId] ?? null);

export const selectIsLoadingHelpCases = createSelector(selectHelpCasesState, (helpCasesState: HelpCasesState) => helpCasesState.loading);
